/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type ComponentType, lazy } from 'react'
import { ViewType, OnlyStorefrontOrStorefrontPro } from '@retailer-platform/dashboard/gin-and-tonic'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { cartAssistantEditorAccessControl } from '../access-control/cartAssistantEditorAccess.configuration'

const CartAssistantEditorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CartAssistantEditorPage" */
      '../pages/cart-assistant-editor/CartAssistantEditorPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// The outer `cart-assistant` route is partner + site scoped and warehouse-less (its URL carries
// `/sites/:storeConfigId` but no `/warehouses/:warehouse_id`; see routes.ts). Its
// <Route> is what puts `storeConfigId` into the router match, which the child editor route's
// <RetailerScopeWrapper> reads via useParams(). DashRoute renders a route's scope wrapper *above* that
// route's own <Route>, so a flat/standalone route can never see its own `:storeConfigId` and the
// wrapper throws on the undefined param. Nesting under a site-scoped parent (as the storefront domain
// does) is the required pattern for a store-config scope picker: even though the picker is STORE_CONFIG
// (site only, no banner/warehouse selected), the wrapper still reads `storeConfigId` from the parent
// match, so the editor must stay nested here.
export const cartAssistantRouter = (
  <DomainRoute route="cart-assistant">
    <DashSwitch>
      <DomainRoute
        exact
        route="cart-assistant-editor"
        component={CartAssistantEditorPage as ComponentType<any>}
        accessControl={cartAssistantEditorAccessControl}
        scopePicker={{
          titles: ['cartAssistantDomain.editor.pageTitle'],
          selectionType: ViewType.STORE_CONFIG,
          storeConfigOperationIntent: 'modify',
          storeConfigFilter: OnlyStorefrontOrStorefrontPro,
        }}
      />
      {/* @hygen:inject router-route */}
    </DashSwitch>
  </DomainRoute>
)
